export default {
  title: 'Tidsopdatering!',
  labels: {
    old_time: 'Tidligere afhentningstid:',
    new_time: 'Ny afhentningstid:',
    old_serve_time: 'Tidligere serveringstid:',
    new_serve_time: 'Ny serveringstid:',
  },
  buttons: {
    print: 'Udskriv og luk',
    got_it: 'Forstået',
  },
  feedback: {
    new_prep_time: 'Leveringstiden er opdateret. Tilpas din tilberedningsplan i overensstemmelse hermed.',
  },
  toasts: {
    something_went_wrong: 'Noget gik galt. Prøv igen',
  },
};
